<div *ngIf="print.load" class="body-wrapper" style="direction: rtl; padding-top: 0">
    <header class="header">
      <div class="justify-between items-center" style="margin-bottom: 5px;text-align: center;margin-bottom: 3%;">
        <!-- <h1 class="header-title">{{'exam.type.GYNE.'+print.exam.ExamType | translate}}</h1> -->
        <h1 class="header-title">טופס שליחת דגימות למעבדת פתולוגיה </h1>
      </div>
      <div class="header-details">
        <div style="display: inline-block; padding-left: 1em;">
          תאריך הבדיקה:&nbsp;<strong style='direction: ltr;'>{{print.exam.CreationTime | date:"dd.MM.yyyy HH:mm"}}</strong>
        </div>
        <div style="display: inline-block">
          תאריך הדפסה:&nbsp;<strong style='direction: ltr;'>{{now| date:"dd.MM.yyyy HH:mm"}}</strong>
        </div>
      </div>
    </header>
    <main class="main">
      <section class="section marginBottom" *ngIf="print.patient">
        <h4 class="text-20 text-gold">פרטי המטופל/ת</h4>
        <div style="width:100%">
          <div>
            <table>
              <tr>
                <td>
                  <dt>שם פרטי </dt>
                  <dd>{{print.patient.First}}</dd>
                </td>
                <td>
                  <dt>שם משפחה</dt>
                  <dd>{{print.patient.Last}}</dd>
                </td>
                <td>
                  <dt>ת.ז</dt>
                  <dd>{{print.patient.ID}}</dd>
                </td>
                <td *ngIf="print.patient.Mobile">
                  <dt>נייד</dt>
                  <dd>{{print.patient.Mobile}}</dd>
                </td>
                <td *ngIf="print.patient.Sex">
                  <dt>מגדר</dt>
                  <dd>{{print.patient.Sex == 'M' ? 'גבר' : 'אישה' }}</dd>
                </td>
                <td *ngIf="print.patient.Address">
									<dt>{{'general.Patient.address' | translate}}</dt>
									<dd>{{print.patient.Address}}</dd>
								</td>
								<td *ngIf="print.patient.City">
									<dt>{{'general.Patient.town' | translate}}</dt>
									<dd>{{print.patient.City}}</dd>
								</td>
								<td *ngIf="print.patient.Zip">
									<dt>{{'general.Patient.zip' | translate}}</dt>
									<dd>{{print.patient.Zip}}</dd>
								</td>
              </tr>
              <tr *ngIf="print.patient.Birth || print.patient.Height || print.patient.Weight">
                <td *ngIf="print.patient.Birth">
                  <dt>תאריך לידה</dt>
                  <dd>{{print.patient.Birth| date:"dd.MM.yyyy"}}</dd>
                </td>
                <td *ngIf="print.patient.Birth">
                  <dt>גיל</dt>
                  <dd>{{print.getAgeMo()}}</dd>
                </td>
                <td *ngIf="print.patient.Height">
                  <dt>גובה</dt>
                  <dd>{{print.patient.Height}}cm</dd>
                </td>
                <td *ngIf="print.patient.Weight">
                  <dt>משקל</dt>
                  <dd>{{print.patient.Weight}}kg</dd>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
      <section class="section" *ngIf="print.gastro  && (print.gastro.Reasone || print.gastro.ASA || print.gastro.Mellampeti )">
        
            <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
            <p class="comment">{{print.gastro.Reasone}}</p>
            <table *ngIf="print.gastro && (print.gastro.ASA || print.gastro.Mellampeti)">
                <tr>
                    <td *ngIf="print.gastro.ASA ">
                        <dt>דירוג ASA </dt>
                        <dd>{{print.gastro.ASA}}</dd>
                    </td>
                    <td *ngIf="print.gastro.Mellampeti ">
                        <dt>דירוג מלמפטי </dt>
                        <dd>{{print.gastro.Mellampeti}}</dd>
                    </td>
                </tr>
            </table>
      
    </section>
      <section class="section marginBottom">
        <h2>דגימות שנאספו</h2>
        <table class="l-table-auto weightAss-table" *ngIf="print.pathology && print.pathology.length > 0">
            <tr class="l-row weightAss-thead">
                <td class="l-td-m" style="width: 10%;">#</td>
                <td class="l-td-m" style="width: 30%; font-weight: 700;">סוג</td>
                <td>Barcode</td>
                <td class="l-td-m" style="width: 60%;font-weight: 700;">הערות</td>
            </tr>
            <ng-container *ngFor="let p of print.pathology;index as i">
                <tr class="l-row weightAss-tbody">
                    <td class="l-td-m" style="width: 10%;">{{i+1}}</td>
                    <td class="l-td-m" style="width: 30%;">{{p.Type}}</td>
                    <td><app-barcode [value]="p.BarCode" *ngIf="p.BarCode"></app-barcode></td>
                    <td class="l-td-m" style="width: 60%;">{{p.Comments}}</td>
                </tr>
            </ng-container>
        </table>
        <section *ngIf="print.gastro && print.gastro.PathologyComments" style="width: 100%;">
            <div class="comment section-inner" style="width: 100%;direction: rtl;">
                <h4>הערות</h4>
                <p>{{print.gastro.PathologyComments}}</p>
            </div>
        </section>
    </section>
        <section class="section marginBottom">
            <h2>ממצאים    {{'exam.type.gastro.'+print.exam.ExamType | translate}}</h2>
            <table style="width: 100%;" *ngIf="print.exam.ExamType !== 'Gastroscopy'">
                <tr *ngIf="print.gastro.Colonoscopy > -1">
                    <td>
                        {{(print.gastro.Colonoscopy == 1  ? '' : 'gastro.Findings.NPD') |
                        translate}}
                    </td>
                    <td *ngIf="print.gastro.Colonoscopy == 0 && print.gastro.FindingsComment">
                        <dt style="width: fit-content;">{{ 'gastro.preparetion.Comments' | translate}}</dt>
                        <dd>{{print.gastro.FindingsComment }}</dd>
                    </td>
                </tr>
                <tr *ngIf="print.gastro && print.gastro && print.gastro.Annus">
                    <td>
                        <strong>{{'gastro.Findings.Anus' | translate}}</strong> {{print.gastro.Annus}}
                    </td>
                </tr>
                <ng-container *ngIf="print.gastro.Colonoscopy == 1">
                    <div style="width: 100%" *ngFor="let d of print.gastro.DetailsFindings; index as i">
                        <tr style="width: 100%; display: flex;">
                            <td style="width: 50%; display: flex;" *ngIf="d.value || d.value === 0 || d.value === 1 || d.comment">
                                <div style="width: 50%;">
                                    <strong>{{ 'gastro.Findings.type.' + d.db | translate }}: </strong>
                                </div>
                                <div style="width: 50%" *ngIf="d.value === 0 || d.value === 1">
                                    {{ (d.value == 1 ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') | translate }}
                                </div>
                            </td>
                            <td style="width: 50%;" *ngIf="d.comment">
                                <strong>{{ 'gastro.preparetion.Comments' | translate }}: </strong>
                                {{ d.comment }}
                            </td>
                        </tr>
                    </div>
                </ng-container>
                
            </table>
            <table *ngIf="print.exam.ExamType == 'Gastroscopy'">
                <tr *ngIf="print.gastro.Esophagus > -1 || print.gastro.EsophagusComment">
                    <td style="width: 10em;">
                        <dt style="width: 5em;">{{'gastro.Findings.Esophagus' | translate}}</dt>
                        <dd *ngIf="print.gastro.Esophagus > -1">{{(print.gastro.Esophagus == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                            translate}}</dd>
                    </td>
                    <td *ngIf="print.gastro.EsophagusComment">
                        <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                        <dd>{{print.gastro.EsophagusComment}}</dd>
                    </td>
                </tr>
                <tr *ngIf="print.gastro.EsoJunction || print.gastro.EsoJunctionComment">
                    <td style="width: 10em;">
                        <dt>{{'gastro.Findings.EsoJunction' | translate}}</dt>
                        <dd *ngIf="print.gastro.EsoJunction">{{print.gastro.EsoJunction}}cm</dd>
                    </td>
                    <td *ngIf="print.gastro.EsoJunctionComment">
                        <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                        <dd>{{print.gastro.EsoJunctionComment}}</dd>
                    </td>
                </tr>
                <tr *ngIf="print.gastro.Stomach > -1 || print.gastro.StomachComment">
                    <td style="width: 10em;">
                        <dt style="width: 5em;">{{'gastro.Findings.Stomach' | translate}}</dt>
                        <dd *ngIf="print.gastro.Stomach > -1 ">{{(print.gastro.Stomach == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                            translate}}</dd>
                    </td>
                    <td *ngIf="print.gastro.StomachComment">
                        <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                        <dd>{{print.gastro.StomachComment}}</dd>
                    </td>
                </tr>
                <tr *ngIf="print.gastro.Duodenum > -1 || print.gastro.DuodenumComment">
                    <td style="width: 10em;">
                        <dt style="width: 5em;">{{'gastro.Findings.Duodenum' | translate}}</dt>
                        <dd *ngIf="print.gastro.Duodenum > -1 ">{{(print.gastro.Duodenum == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                            translate}}</dd>
                    </td>
                    <td *ngIf="print.gastro.DuodenumComment">
                        <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                        <dd>{{print.gastro.DuodenumComment}}</dd>
                    </td>
                </tr>
            </table>
            <section class="section" *ngIf="print.gastro.ColoComment">
                <h4>{{'gastro.preparetion.Comments' | translate}}</h4>
                <p class="comment">{{print.gastro.ColoComment}}</p>
            </section>
        </section>
        <!-- אבחנות -->
        <section class="section" *ngIf="print.gastro && (print.gastro.DiagnosisList?.length > 0 || print.gastro.Diagnosis)">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.gastro.DiagnosisList" >
                <table class="w100"><tr *ngFor="let d of print.gastro.DiagnosisList">
                    <p class="comment" style="text-align: justify;">
                        {{d.value}}
                    </p>
                </tr></table>
            </ng-container>
            <section *ngIf="print.gastro.Diagnosis" style="text-align: justify;">
                <p class="comment">{{print.gastro.Diagnosis}}</p>
            </section>
        </section>
        <!-- <section class="section" *ngIf="print.gastro && (print.gastro.DiagnosisList?.length > 0 || print.gastro.Diagnosis)">
            <h2> אושר בהצלבה על ידי {{print.exam.Title}} {{print.exam.Name}}</h2>
            <span style="width: 70%;border-bottom: 1px solid black;"></span>
        </section> -->
        <div class="section" style="width: 70%;display: flex;align-items: center;margin:0 0 0 0.5em;font-size:large;margin-top: 5%;" >
            <span style="width: 40%;">אושר בהצלבה על ידי :</span>
            <span *ngIf="!print.signatureUrl" style="width: 70%;border-bottom: 1px solid black;"></span>
            <span *ngIf="print.signatureUrl" style="width: 70%;display: flex;align-items: center;">
                <img [src]="print.signatureUrl" style="max-height: 80px;">
            </span>
            <!-- <hr style="align-self: end;bottom: auto;vertical-align: baseline;"> -->
        </div>
    </main>
  </div>
  